import { render, staticRenderFns } from "./AnswerInputTable.vue?vue&type=template&id=1c5586fc&scoped=true&"
import script from "./AnswerInputTable.vue?vue&type=script&lang=ts&"
export * from "./AnswerInputTable.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerInputTable.vue?vue&type=style&index=0&id=1c5586fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5586fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
